import { render } from "./rectification.vue?vue&type=template&id=6d352b98&scoped=true&ts=true"
import script from "./rectification.vue?vue&type=script&lang=ts"
export * from "./rectification.vue?vue&type=script&lang=ts"

import "./rectification.vue?vue&type=style&index=0&id=6d352b98&scoped=true&lang=less"
import "./rectification.vue?vue&type=style&index=1&id=6d352b98&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d352b98"]])

export default __exports__